"use client";

import { VenueInfoTags, VenueInfoTagsProps } from "./VenueInfoTags";

import { useVenuePageTheme } from "../../hooks/venuePages/useVenuePageTheme";

export interface VenueInfoTagsThemedProps extends Omit<
  VenueInfoTagsProps,
  "accentColor"
> {}

export function VenueInfoTagsThemed({
  venuePage,
  ...rest
}: VenueInfoTagsThemedProps) {
  const { accentColor } = useVenuePageTheme(venuePage.slug);
  return (
    <VenueInfoTags accentColor={accentColor} venuePage={venuePage} {...rest} />
  );
}
